import React, { Component } from 'react';
import { getPublicSettings } from './models/setting';

import CacheBuster from './components/cachebuster';
import ErrorBoundary from './ErrorBoundary';
import Router from '../localmikvah/router';

import './fontAwesome';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      isLoaded: false,
      mikvah: null
    };
  }

  componentDidMount() {
    let localStorageSettings = JSON.parse(localStorage.getItem('settings'));
    if(localStorageSettings&&localStorageSettings.data&&localStorageSettings.data.mikvahName){
      this.setState({mikvah: localStorageSettings.data.mikvahName.value});
    }
    getPublicSettings()
      .then(
        settings=>{
          if(!localStorageSettings||(localStorageSettings&&localStorageSettings.data&&localStorageSettings.data.mikvahName&&localStorageSettings.data.mikvahName.value!==settings.mikvahName.value)){
            this.setState({mikvah: settings.mikvahName.value});
          }
        }
    );    
  }

  render() {
    return (
      <ErrorBoundary><CacheBuster>
        {({ loading, isLatestVersion, refreshCacheAndReload }) => {
          if (loading) return null;
          if (!loading && !isLatestVersion) {
            // You can decide how and when you want to force reload
            refreshCacheAndReload();
          }

          return <>
            <Router />
            <div className="version">v{global.appVersion}</div>
          </>;
        }}
      </CacheBuster></ErrorBoundary>
    );
  }
}

export default App;
